import { useContext, useEffect, useRef } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import CompanyContext from "contexts/CompanyContext";
import { SettingsTabs } from "components/Settings/SettingsModal";

/**
 * Otwiera modal Ustawień na właściwej zakładce na podstawie parametrów URL (deep-link z maili).
 * Np. link z maila „Potwierdź płatność": `?settingsTab=payments&paymentTab=settlements`
 * → otwiera Ustawienia → Płatności; pod-zakładkę (`paymentTab`) czyta już sam PaymentsTab.
 *
 * Czeka aż załaduje się firma (CompanyContext): dopiero wtedy mirror workspaceId
 * (getCompanyId) jest ustawiony, więc Rozliczenia wczytają się z właściwej firmy.
 * Renderuje null — działa przez efekt.
 */
const DeepLinkHandler = () => {
  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);
  const { hasCompany, isLoading } = useContext(CompanyContext);
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    // Bez załadowanej firmy getCompanyId() === null → Rozliczenia nie miałyby czego pobrać.
    if (isLoading || !hasCompany) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get("settingsTab") === "payments") {
      handledRef.current = true;
      setOptions({ initialTab: SettingsTabs.Payments });
      setModals({ ...modals, settings: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCompany, isLoading]);

  return null;
};

export default DeepLinkHandler;
